module.exports = __webpack_public_path__ + "static/img/joinBanner3.2a6071f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner3.jpg
// module id = IgND
// module chunks = 0